<script>
import AppScrollObject from '../app-scroll-object/index.vue'
export default {
  name:'app-home-slide',
  props: {
                      debug: {
                          type: Boolean,
                          default: !1
                      },
                     content: {
                         type: Object,
                         default: function() {}
                     },
                     adminContent: {
                         type: Object,
                         default: function() {}
                     },
                     activeIndex: {
                         type: Number,
                         default: 0
                     },
                     indexSS: {
                         type: Number,
                         default: 0
                     },
                     hasVideo: {
                         type: Boolean,
                         default: !1
                     },
                     navOffsetTop: {
                         type: Number,
                         default: 0
                     },
                     headerPageSize: {
                         type: Array,
                         default: function() {}
                     },
                     IsTolltipPopDisabled:{
                       type: Boolean,
                       default: !1
                     }
                 },
                 data: function() {
                     return {
                         isActive: !1,
                         popinContent: null,
                         popinIndex: 0,
                         isPopinActive: !1,
                         isBoardActive: !1,
                         IsActiveCountUp:!1,
                         OfficesVal:0,
                         ClientsVal:0,
                         EmployeesVal:0,
                         SectorsVal:0,

                     }
                 },
                 computed:{

                   myStylesTransform2()
                   {
                       return {
                           transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                       }
                   },
                   myStylesWidthHeight()
                   {
                        return {
                         width: this.headerPageSize[0] + "px",
                         height: this.headerPageSize[1] + "px"

                       }
                   }
                 },
                 components:
                 {
                  AppScrollObject
                 },
                 watch:
                 {
                     activeIndex: "onActiveIndexChange"
                 },
                 created: function()
                 {
                     this._transitionDuration = 1200,
                     this.eventHub.$on("resize", this.onResize),
                     this.eventHub.$on("close:popin", this.onClosePopin)//,
                    // this.$video.play()

                 },
                 destroyed: function ()
                 {
                     this.eventHub.$off("resize", this.onResize),
                     this.eventHub.$off("close:popin", this.onClosePopin)
                 },
                 mounted: function()
                 {
                     //RAthis.hasVideo && (this.$video = this.$el.querySelector(".js-video")),
                     0 === this.indexSS ? this.$el.classList.add("is-active") : this.$el.style.visibility = "hidden",
                     this.$imagesContainer = this.$el.querySelectorAll(".js-photo-container")

                 },
                 methods:
                 {
                    onActiveIndexChange: function()
                     {
                        var t = this;
                         this.$el.style.transform = "translateY(" + 100 * -this.activeIndex + "%) translateZ(0)",
                          clearTimeout(this._visibilityTimer),
                          this.indexSS === this.activeIndex
                           ?
                          (this.$el.classList.remove("is-leaving"),
                          setTimeout(function() {   t.$el.classList.add("is-active")   }, 10),
                           this.isActive = !0,
                            this.$el.style.visibility = "visible")
                          :
                          this.isActive
                          &&
                           (this.$el.classList.add("is-leaving"),
                          this.$el.classList.remove("is-active"),
                          this.isActive = !1,
                          this._visibilityTimer = setTimeout(function() {   t.$el.style.visibility = "hidden", t.$el.classList.remove("is-leaving") },
                           this._transitionDuration))//,

                     },

                     _onLoadMemberImage: function (t)
                     {
                         this.$imagesContainer[t].classList.remove("is-loading")
                     },

                     onTransition: function ()
                     {
                         var t = this;
                         this.$el.classList.add("is-switching"),
                         clearTimeout(this._timerTransition),
                         this._timerTransition = setTimeout(function () {
                             t.$el.classList.remove("is-switching")
                         }, 650)
                     }
              }
}
</script>
